import * as n from "react";
import T from "react";
import { c as K, b as R, e as V, u as W } from "./chunk-PVWAREVJ-BO6B-RAk.js";
const L = {}, D = T.createContext(L);
function X(e) {
  const t = T.useContext(D);
  return T.useMemo(
    function() {
      return typeof e == "function" ? e(t) : { ...t, ...e };
    },
    [t, e]
  );
}
function Y(e) {
  let t;
  return e.disableParentContext ? t = typeof e.components == "function" ? e.components(L) : e.components || L : t = X(e.components), T.createElement(
    D.Provider,
    { value: t },
    e.children
  );
}
var z = (e, t, r, u, m, l, d, h) => {
  let i = document.documentElement, v = ["light", "dark"];
  function f(o) {
    (Array.isArray(e) ? e : [e]).forEach((y) => {
      let S = y === "class", P = S && l ? m.map((b) => l[b] || b) : m;
      S ? (i.classList.remove(...P), i.classList.add(l && l[o] ? l[o] : o)) : i.setAttribute(y, o);
    }), k(o);
  }
  function k(o) {
    h && v.includes(o) && (i.style.colorScheme = o);
  }
  function c() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  if (u) f(u);
  else try {
    let o = localStorage.getItem(t) || r, y = d && o === "system" ? c() : o;
    f(y);
  } catch {
  }
}, _ = ["light", "dark"], N = "(prefers-color-scheme: dark)", J = typeof window > "u", M = n.createContext(void 0), $ = { setTheme: (e) => {
}, themes: [] }, Z = () => {
  var e;
  return (e = n.useContext(M)) != null ? e : $;
}, ee = (e) => n.useContext(M) ? n.createElement(n.Fragment, null, e.children) : n.createElement(F, { ...e }), j = ["light", "dark"], F = ({ forcedTheme: e, disableTransitionOnChange: t = !1, enableSystem: r = !0, enableColorScheme: u = !0, storageKey: m = "theme", themes: l = j, defaultTheme: d = r ? "system" : "light", attribute: h = "data-theme", value: i, children: v, nonce: f, scriptProps: k }) => {
  let [c, o] = n.useState(() => U(m, d)), [y, S] = n.useState(() => c === "system" ? x() : c), P = i ? Object.values(i) : l, b = n.useCallback((a) => {
    let s = a;
    if (!s) return;
    a === "system" && r && (s = x());
    let g = i ? i[s] : s, A = t ? q(f) : null, C = document.documentElement, I = (p) => {
      p === "class" ? (C.classList.remove(...P), g && C.classList.add(g)) : p.startsWith("data-") && (g ? C.setAttribute(p, g) : C.removeAttribute(p));
    };
    if (Array.isArray(h) ? h.forEach(I) : I(h), u) {
      let p = _.includes(d) ? d : null, H = _.includes(s) ? s : p;
      C.style.colorScheme = H;
    }
    A?.();
  }, [f]), w = n.useCallback((a) => {
    let s = typeof a == "function" ? a(c) : a;
    o(s);
    try {
      localStorage.setItem(m, s);
    } catch {
    }
  }, [c]), E = n.useCallback((a) => {
    let s = x(a);
    S(s), c === "system" && r && !e && b("system");
  }, [c, e]);
  n.useEffect(() => {
    let a = window.matchMedia(N);
    return a.addListener(E), E(a), () => a.removeListener(E);
  }, [E]), n.useEffect(() => {
    let a = (s) => {
      s.key === m && (s.newValue ? o(s.newValue) : w(d));
    };
    return window.addEventListener("storage", a), () => window.removeEventListener("storage", a);
  }, [w]), n.useEffect(() => {
    b(e ?? c);
  }, [e, c]);
  let O = n.useMemo(() => ({ theme: c, setTheme: w, forcedTheme: e, resolvedTheme: c === "system" ? y : c, themes: r ? [...l, "system"] : l, systemTheme: r ? y : void 0 }), [c, w, e, y, r, l]);
  return n.createElement(M.Provider, { value: O }, n.createElement(Q, { forcedTheme: e, storageKey: m, attribute: h, enableSystem: r, enableColorScheme: u, defaultTheme: d, value: i, themes: l, nonce: f, scriptProps: k }), v);
}, Q = n.memo(({ forcedTheme: e, storageKey: t, attribute: r, enableSystem: u, enableColorScheme: m, defaultTheme: l, value: d, themes: h, nonce: i, scriptProps: v }) => {
  let f = JSON.stringify([r, t, l, e, h, d, u, m]).slice(1, -1);
  return n.createElement("script", { ...v, suppressHydrationWarning: !0, nonce: typeof window > "u" ? i : "", dangerouslySetInnerHTML: { __html: `(${z.toString()})(${f})` } });
}), U = (e, t) => {
  if (J) return;
  let r;
  try {
    r = localStorage.getItem(e) || void 0;
  } catch {
  }
  return r || t;
}, q = (e) => {
  let t = document.createElement("style");
  return e && t.setAttribute("nonce", e), t.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")), document.head.appendChild(t), () => {
    window.getComputedStyle(document.body), setTimeout(() => {
      document.head.removeChild(t);
    }, 1);
  };
}, x = (e) => (e || (e = window.matchMedia(N)), e.matches ? "dark" : "light");
const te = () => {
  const e = K(), t = R(), [r, u] = V(), m = W();
  return { location: e, navigate: t, params: m, searchParams: r, setSearchParams: u };
};
export {
  ee as J,
  Y as M,
  te as a,
  X as u,
  Z as z
};
//# sourceMappingURL=useExposedProps-B8NHdNRq.js.map
